//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosPost } from '../../../axios/axios.js'
import { convertTime } from '../../../components/helpers.js'

import ReportForkliftTruckSelector from './ReportForkliftTruckSelector.vue'
import VehicleProvisionDispatcher from '../../VehicleProvision/VehicleProvisionDispatcher.vue'

export default {
  components: {
    ReportForkliftTruckSelector
  },
  props: {
    report: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      pagination: {
        rowsPerPage: 25,
        page: 1
      },
      columns: [
        {
          name: 'vehicle',
          label: 'ТС',
          align: 'left',
          field: 'vehicle',
          sortable: false
        },
        {
          name: 'notActual',
          label: 'Отсутствовало на объекте',
          labelTable: 'Отсутствовало<br>на объекте',
          align: 'left',
          field: 'notActual',
          sortable: false
        },
        {
          name: 'comment',
          label: 'Причина отсутствия',
          labelTable: 'Причина<br>отсутствия',
          align: 'left',
          field: 'comment',
          sortable: false
        },
        {
          name: 'startTime',
          label: 'Начало работы',
          align: 'left',
          field: 'startTime',
          format: convertTime
        },
        {
          name: 'endTime',
          label: 'Окончание работы',
          align: 'left',
          field: 'endTime',
          format: convertTime
        }
      ],
      absent: true
    }
  },
  computed: {
    editable: function () {
      return !!(this.report.actionsAccess && (this.report.actionsAccess.saveAccess || this.report.actionsAccess.editData)) && !this.report.actionsAccess.reinforcementExecutor // && this.report.stateId !== 'PR7'
    },
    readonly: function () {
      return !this.editable
      // return !(this.report.actionsAccess && this.report.actionsAccess.editData)
    }
  },
  methods: {
    onOpenVehicleProvision: function (vehicleProvisionId) {
      this.$d.dialog(this).show({
        maximized: true,
        persistent: true,
        headerHidden: true,
        contentComponent: VehicleProvisionDispatcher,
        contentProps: {
          vehicleProvisionId: vehicleProvisionId,
          dialog: true
        }
      })
    },
    onChangeNotActual: function (row, notActual) {
      if (notActual) {
        this.$d_ask({
          callback: (data, action) => {
            if (action === 'yes') {
              this.actualize(row.vehicleProvisionId, row.startTime, data.comment, notActual).then(() => {
                row.notActual = notActual
              })
            }
          },
          header: 'Спецтехника отсутствовала?',
          propsConfig: {
            comment: { type: 'text', label: 'Причина', required: true }
          },
          buttons: {
            yes: 'Да',
            cancel2: 'Отмена'
          }
        })
      } else {
        this.actualize(row.vehicleProvisionId, row.startTime, '', notActual).then(() => {
          row.notActual = notActual
          this.$emit('updated')
        })
      }
    },
    actualize: function (vehicleProvisionId, startTime, comment, notActual) {
      const bodyFormData = new FormData()
      if (this.report.id != null && vehicleProvisionId != null) {
        bodyFormData.set('requestReportId', this.report.id)
        bodyFormData.set('vehicleProvisionId', vehicleProvisionId)
        bodyFormData.set('startTime', startTime)
        bodyFormData.set('notActual', notActual)
        bodyFormData.set('comment ', comment)

        return axiosPost({
          url: '/service/delta/vehicleProvision/actualize',
          data: bodyFormData,
          onSuccess: (response) => {
            this.$q.notify({
              type: 'positive',
              message: 'Успешно актуализировано наличие спецтехники',
              progress: true,
              timeout: 3000
            })
            this.$emit('updated')

            return Promise.resolve(response)
          },
          onFailure: (response) => {
            this.$q.notify({
              type: 'negative',
              message: response.message,
              progress: true,
              timeout: 8000
            })

            return Promise.reject(Error(response.message))
          }
        })
      }
    },
    onAddForkliftTruck: function () {
      this.$refs.forkliftTruckSelector.open({
        callback: (result) => {
          return this.addReportInterval(result)
        }
      })
    },
    addReportInterval: function (vehicleId) {
      return this.editReportInterval('addReportInterval', vehicleId)
    },
    onDelete: function (row) {
      if (row.vehicle) {
        return this.editReportInterval('deleteReportInterval', row.vehicle.id, null, row.startTime, row.endTime)
      }
    },
    onEdit: function (row) {
      const oldStartTime = row.startTime
      this.$d_ask({
        callback: (data, action) => {
          if (action === 'yes') {
            this.editReportInterval('editReportInterval', row.vehicle.id, oldStartTime, data.startTime, data.endTime)
          }
        },
        header: 'Редактирование интервала работы спецтехники',
        propsConfig: {
          startTime: { type: 'datetime', label: 'Начало', required: true, value: row.startTime },
          endTime: { type: 'datetime', label: 'Окончание', value: row.endTime }
        },
        buttons: { yes: 'Сохранить', cancel: 'Отмена' }
      })
    },
    editReportInterval: function (action, vehicleId, oldStartTime = null, startTime = null, endTime = null) {
      const bodyFormData = new FormData()
      if (action != null && this.report.id != null && vehicleId != null) {
        bodyFormData.set('requestReportId', this.report.id)
        bodyFormData.set('vehicleId', vehicleId)

        if (oldStartTime) {
          bodyFormData.set('oldStartTime', oldStartTime)
        }
        if (startTime) {
          bodyFormData.set('startTime', startTime)
        }
        if (endTime) {
          bodyFormData.set('endTime', endTime)
        }

        return axiosPost({
          url: '/service/delta/vehicleProvision/' + action,
          data: bodyFormData,
          onSuccess: (response) => {
            this.$q.notify({
              type: 'positive',
              message: 'Успешно изменена запись о спецтехнике',
              progress: true,
              timeout: 3000
            })
            this.$emit('updated')

            return Promise.resolve(response)
          },
          onFailure: (response) => {
            this.$q.notify({
              type: 'negative',
              message: response.message,
              progress: true,
              timeout: 8000
            })

            return Promise.reject(Error(response.message))
          }
        })
      }
    }
  }
}

